import axios from 'axios';

const HOST_API = process.env.REACT_APP_URL;

// Mientras no exista el endpoint en administracionBack, las respuestas se
// generan localmente. Cuando el backend esté listo, alcanza con que
// api/chat/enviar responda { respuesta: string } y el fallback deja de usarse.
export const sendChatMessage = async (mensaje, historial = []) => {
    try {
        const { data } = await axios.post(`${HOST_API}api/chat/enviar`, { mensaje, historial });
        return data.respuesta;
    } catch (error) {
        return respuestaLocal(mensaje);
    }
};

const respuestaLocal = (mensaje) => {
    const texto = mensaje.toLowerCase();

    if (texto.includes('expensa')) {
        return 'Podés consultar tus expensas desde la sección "Estado de Cuenta" del menú.';
    }
    if (texto.includes('reclamo')) {
        return 'Para cargar un reclamo, andá a la sección "Reclamos" del menú.';
    }
    if (texto.includes('visita')) {
        return 'Podés avisar una visita desde la sección "Avisar Visita".';
    }
    if (texto.includes('hola') || texto.includes('buen')) {
        return '¡Hola! ¿En qué puedo ayudarte?';
    }

    return 'Todavía no tengo una respuesta para eso, pero pronto voy a poder ayudarte con más temas.';
};
